import { Link, useParams } from "react-router-dom";
import { cars } from "../../dataSingleCars";
import SingleCarTop from "./SingleCarTop";
import SingleCarBottom from "./SingleCarBottom";
import { motion } from "framer-motion";
import { useState } from "react";
import buscar from "./images/buscar.png";
import coche from "./images/coche.png";
import './cars.css'
import llave from "./images/llave-inglesa.png";
import React, { useCallback, Suspense } from "react";
import Loading from "../Loading/Loading";
const LoanCalc = React.lazy(() => import("./LoanCalc"));


export default function SingleCar(props) {
  const { carId } = useParams();
  const car = cars.find(({ id }) => id === carId);
  const { marca, modelo, price, mpg, mpge, hc, fc, miles, battery, accel, hp } =
    car;
  const [open, setOpen] = useState(false);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  return (
    <motion.section
      initial={{ x: 300, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: 300, opacity: 0, transition: 0.2 }}
      transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <article className="single-car-container">
        <div className="single-car">
          <Link to="/cars" className="back-to-cars-boton">
            <button>← Back to cars</button>
          </Link>

          <div className="single-car-top-container-top">
            <SingleCarTop
              titulo="WIDE RANGE OF BRANDS"
              span="Our service department maintains your vehicle"
              src={buscar}
              alt="description"
            />
            <SingleCarTop
              titulo="CAR SERVICE & MAINTENANCE"
              span="Stay safe on the road for many more years"
              src={llave}
              alt="description"
            />
            <SingleCarTop
              titulo="TRUSTED BY THOUSANDS"
              span="Department maintain your car to stay safe"
              src={coche}
              alt="description"
            />
          </div>
          <div className="single-car-box">
            <div className="single-car-titulo-container">
              <h4>
                {marca} {modelo} 2023
              </h4>
            </div>
            <div className="single-car-image-button-container">
              <div className="single-car-box-container">
                <div className="single-car-b-1">
                  <div>
                    <p className="p-p">
                      MSRP: <span>${price + 2000}</span>
                    </p>
                    <p className="b-p-p">${price}</p>
                  </div>
                  <div>
                    <Link to="/contact">
                      <button>CONTACT INFORMATION</button>
                    </Link>
                  </div>
                </div>
                <div className="single-car-b-2">
                  <div>
                    <p>
                      <span>{mpg}</span>
                      <br />
                      CITY MPGe
                    </p>
                  </div>
                  <div className="single-car-image-boxes">
                    <img
                      src={require("../Hero/images/mercedes-logo.png")}
                      alt="car-logo"
                    />
                  </div>
                  <div>
                    <p>
                      <span>{mpge}</span>
                      <br />
                      HWY MPGe
                    </p>
                  </div>
                </div>
                <div className="single-car-b-3">
                  <div>
                    <h5>BATTERY CHARGING TIME</h5>
                  </div>
                  <div className="single-car-b-3-sub">
                    <div>
                      <p>
                        <span className="single-car-span">{hc} hrs</span>
                        <br />
                        Home Charge AC 16A
                      </p>
                    </div>
                    <div className="single-car-image-boxes">
                      <img
                        src={require("../Hero/images/mercedes-logo.png")}
                        alt="car-logo"
                      />
                    </div>
                    <div>
                      <p>
                        <span className="single-car-span">{fc} hrs</span> <br />
                        Fast Charge DC 64A
                      </p>
                    </div>
                  </div>
                  <div>
                    <span>Charging from 0% to 80%</span>
                  </div>
                </div>
              </div>
              <div className="imagen-single-car-bottom">
                <div className="single-car-boton-container">
                  <button>Share</button>
                  <button>Add to compare</button>
                </div>
                <div>
                  <img
                    src={`https://cdn.imagin.studio/getImage?&angle=01&billingTag=web&customer=carwow&make=${car.marca}&modelFamily=${car.modelo}&modelYear=2023&paintId=&powerTrain=fossil&trim=0&width=&zoomType=relative&format=webp`}
                    alt="car-image"
                  />
                </div>
                <div className="single-car-buttons">
                  <button onClick={() => setOpen(true)}>LOAN CALCULATOR</button>
                  <button>VIN REPORT</button>
                  <button>TEST DRIVE</button>
                  <button>CAR BORCHURE</button>
                </div>
              </div>
            </div>
          </div>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <LoanCalc
              open={open}
              modelo={modelo}
              marca={marca}
              price={price}
              onClose={handleClose}
            />
          </Suspense>
          <div className="single-car-bottom-container">
            <SingleCarBottom
              subtitle="Electric Range"
              data={miles + "mi"}
              number="1"
            />
            <SingleCarBottom
              subtitle="Battery Size"
              data={battery + "kWh"}
              number="2"
            />
            <SingleCarBottom
              subtitle="0-60 mph"
              data={accel + "s"}
              number="4"
            />
            <SingleCarBottom subtitle="Power" number="3" data={hp + "hp"} />
          </div>
        </div>
      </article>
    </motion.section>
  );
}
